/* eslint-disable max-len */

import messages from 'src/messages';

const DEFAULT_ERROR_CODE = '000';

const errCodeToMessageMap = ({
  GENERAL: messages.defaultApiErrorMessage,
  '000': messages.defaultApiErrorMessage,
  INVALID_JSON_REQUEST: messages.defaultApiErrorMessage,
  INVALID_SETTING: messages.invalidSetting,
  INVALID_CART_REQUEST: messages.invalidCart,
  RNA_INVALID_RESEARCHER_NAME_LENGTH: messages.invalidResearcherName,
  RNA_INVALID_OLIGO_NAME_LENGTH: messages.invalidOligoName,
});

const getErrMsgByErrCode = (code, paramValues) => {
  const message = errCodeToMessageMap[code] || messages.defaultApiErrorMessage;

  return { ...message, values: paramValues || {} };
};

export const getErrorMessagesFromResponse = async (apiResponse) => {
  const response = apiResponse;

  const errMessages = response.errors || [];

  return errMessages.map((msg) => {
    const code = msg.code || DEFAULT_ERROR_CODE;

    return getErrMsgByErrCode(code, msg.paramValues);
  });
};
